import script from "./rule.vue?vue&type=script&setup=true&lang=js"
export * from "./rule.vue?vue&type=script&setup=true&lang=js"

import "./rule.vue?vue&type=style&index=0&id=42fddc3b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fddc3b"]])

export default __exports__